module.exports = __webpack_public_path__ + "static/mail_qiye_qq-643beb8f23e6bdb97f02b57b180d9cd6.png";